import React from 'react';
import './editor.scss';
import { PanelBody, PanelRow, TextControl, TextareaControl, SelectControl, FlexItem, Flex } from '@wordpress/components';
import {
	useBlockProps,
	InspectorControls,
} from '@wordpress/block-editor';

export default function Edit( { attributes, setAttributes } ) {
	const hours = Array.from({ length: 24 }, (_, i) => {
		const value = String(i).padStart(2, '0');
		return { label: value, value };
	});

	const minutes = Array.from({ length: 60 }, (_, i) => {
		const value = String(i).padStart(2, '0');
		return { label: value, value };
	});

	return (
		<div { ...useBlockProps() }>
			<InspectorControls key="setting">
				<PanelBody title="Configurações do Evento" initialOpen={true}>
					<PanelRow>
						<TextControl
							label="Título"
							placeholder='Título do Evento'
							value={attributes.title}
							onChange={(value) => setAttributes({ title: value })}
						/>
					</PanelRow>
					<PanelRow>
						<Flex>
							<FlexItem>
								<SelectControl
									label="Hora"
									value={attributes.start_hour}
									options={hours }
									onChange={(value) => setAttributes({ start_hour: value })}
								/>
							</FlexItem>
							<FlexItem>
								<SelectControl
									label="Minuto"
									value={attributes.start_minute}
									options={minutes}
									onChange={(value) => setAttributes({ start_minute: value })}
								/>
							</FlexItem>
						</Flex>
					</PanelRow>
					<PanelRow>
						<Flex>
							<FlexItem>
								<SelectControl
									label="Hora"
									value={attributes.end_hour}
									options={hours }
									onChange={(value) => setAttributes({ end_hour: value })}
								/>
							</FlexItem>
							<FlexItem>
								<SelectControl
									label="Minuto"
									value={attributes.end_minute}
									options={minutes}
									onChange={(value) => setAttributes({ end_minute: value })}
								/>
							</FlexItem>
						</Flex>
					</PanelRow>										
					<PanelRow>
						<TextControl
							label="Local"
							placeholder='Local do evento'
							value={attributes.locale}
							onChange={(value) => setAttributes({ locale: value })}
						/>
					</PanelRow>
					<PanelRow>
						<TextareaControl
							__nextHasNoMarginBottom
							label="Participantes"
							help="Participantes do evento"
							value={attributes.participants}
							onChange={( value ) => setAttributes({ participants: value })}
						/>
					</PanelRow>
					<PanelRow>
						<TextControl
							label="Mensagem de alteração"
							placeholder='Mensagem de alteração'
							value={attributes.update_message}
							onChange={( value ) => setAttributes({ update_message: value })}
						/>
					</PanelRow>					
				</PanelBody>
			</InspectorControls>
			<div>{attributes.title}</div>
			<div>{attributes.start_hour}:{attributes.start_minute}</div>
			<div>{attributes.end_hour}:{attributes.end_minute}</div>
			<div>{attributes.locale}</div>
			<div>{attributes.participants}</div>
			<div>{attributes.update_message}</div>
		</div>
	);
}